<template>
    <div id="lock">
        <el-table empty-text="Geen gebruiker gevonden..." v-loading.body="loading" element-loading-text="Laden..." :stripe=true :border=true :data="Users">
    
            <el-table-column label="School" prop="tbl_school.name">
            </el-table-column>
            <el-table-column label="User ID" prop="id">
            </el-table-column>
            <el-table-column label="Username" prop="username">
            </el-table-column>
            <el-table-column label="Firstlogin" prop="firstlogin">
                <template slot-scope="scope">
                    <el-checkbox v-model="selected_firstlogin[scope.$index]" @change="flClick(scope.row.id,(scope.row.firstlogin? 0 : 1))"></el-checkbox>
                </template>
            </el-table-column>
            <el-table-column label="System Locked" prop="locked_system">
                <template slot-scope="scope">
                    <el-checkbox v-model="selected_locked[scope.$index ]" @change="slClick(scope.row.id,(scope.row.locked_system? 0 : 1))"></el-checkbox>
                </template>
            </el-table-column>
            <el-table-column label="Roles" prop="firstlogin">
                <template slot-scope="scope">
                    <el-select size="small" style="width:100px;" @change="role_save(scope.row.id,selected_roles[scope.$index]);" v-model="selected_roles[scope.$index]" filterable placeholder="">
                        <el-option v-for="item in Roles" :label="item.name" :value="item.id" :key="item.id">
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>
    
        </el-table>
    </div>
</template>

<script>
import Axios from 'axios'
//import Icon from 'vue-awesome/components/Icon.vue'
import { API_ROOT } from '../config'

var instance = Axios.create({
    baseURL: API_ROOT,
    timeout: 60000

});



export default {
    name: 'lock',
    created: function () {
        //this.getUnits()
        // if (_.isUndefined(this.user.data)) {
        //     this.$router.push({
        //         path: '/'
        //     });
        // }
        this.getRoles();
       
     

    },

    data: function () {
        return {
            Roles: [],
            selected_roles: [],
            selected_firstlogin: [],
            boards: [],
            selected_locked: [],
            Users: [],
            loading: true
        }
    },
    watch: {

    },
    computed: {
        user() {
            return this.$store.getters.getUser;
        },
        loggedin() {
            return this.$store.getters.getLoggedin;
        }
    },
    methods: {
        handleEdit(index, row) {
            console.log(index, row);
        },
        flClick(id, value) {
            instance.post('/user/set-firstlogin', {
                id: id,
                firstlogin: value
            }).then(function (response) {
                //console.log(response.data.data);
            });
        },
        slClick(id, value) {
            instance.post('/user/set-lockedsystem', {
                id: id,
                locked_system: value
            }).then(function (response) {
                //console.log(response.data.data);
            });
        },
        role_save(id,value){
            instance.post('/userrol-update', {
                id: id,
                role_id: value
            }).then(function (response) {
                //console.log(response.data.data);
            });
        },
        getUsers: function () {
            var self = this;
            //console.log(this.selected_class);
            this.params = this.$route.params;
            console.log(this.$route);

            instance.get('/user').then(function (response) {

               
                _.merge(self.Users, response.data.data);

                for (var i = 0; i < self.Users.length; i++) {

                    var role = self.Users[i].tbl_sys_userrols[0];
                    console.log(i);
                    console.log(role);

                    self.selected_firstlogin.push(self.Users[i].firstlogin);
                    self.selected_locked.push(self.Users[i].locked_system);
                    if (role)
                    {
                        self.selected_roles.push(role.role_id);
                    }
                    
                }
                self.loading = false;
                console.log(self.selected_roles);

            });

        },
        getRoles: function () {
            var self = this;
            //console.log(this.selected_class);
            this.params = this.$route.params;
            console.log(this.$route);

            instance.get('/role').then(function (response) {

                console.log(response.data.data);
                console.log(self.Roles);
                _.merge(self.Roles, response.data.data);

                 self.getUsers();

 
              

            });

        }
    }
}
</script>
<style scoped>
.layout {
    height: 540px;
    overflow-y: scroll;
    ;
    z-index: 1;
}

.text {
    font-size: 10px;
}

body {
    margin-top: 30px;
    margin-right: 250px;
    margin-left: 250px;
    margin-bottom: 60px;
}
</style>
